module.exports = __webpack_public_path__ + "img/icon_notice.8ded206.png";